import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Widget } from "@/core/modules/widget/objects/Widget";
import { widgetModel } from "../WidgetModel";

export const getWidgetByTypeAndSourceAndSourceId = async (type: string, source: string, sourceId: string): Promise<Widget | undefined> => {
  try {
    if (type == undefined) throw new Error("Type is undefined");
    if (source == undefined) throw new Error("Source is undefined");
    if (sourceId == undefined) throw new Error("SourceId is undefined");

    const snapshotQuery: Query<Widget> = query(
      widgetModel.getPathReference().withConverter(widgetModel.firestoreConverter),
      where("type", "==", type),
      where("source", "==", source),
      where("sourceId", "==", sourceId)
    );

    const snapshot: QuerySnapshot<Widget> = await getDocs(widgetModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return undefined;

    return snapshot.docs[0].data();
  } catch (error: unknown) {
    appFaultModel.catchAppError("WidgetModel.getWidgetByTypeAndSourceAndSourceId", { type, source, sourceId }, error);
    return undefined;
  }
};
